<template>
  <div id="circleDetail">
    <div class="detail">
      <div class="box">
        <van-image class="img" :src="require('@/assets/images/issue/img_01.png')" fit="cover"></van-image>
        <div class="right">
          <div class="right-top">
            <div class="title">{{detail.name}}</div>
            <div class="sum">
              <div class="item">
                <div class="label">关注</div>
                <div class="value">{{detail.followers}}</div>
              </div>
              <div class="item">
                <div class="label">问题</div>
                <div class="value">{{detail.question}}</div>
              </div>
            </div>
          </div>
          <div class="right-bottom">
            <div class="btns">
              <button v-if="detail.followStatus" class="btn" @click="onFollow">已关注</button>
              <button v-else class="btn btn-1"  @click="onFollow">关注</button>
            </div>
          </div>
        </div>
      </div>
      <div class="textarea">
        <MoreInfo
          v-model="isMore"
          class="more-info"
          :line="3"
          content="<p>简介：随着新课标、新教材的推广和实施，为进一步发挥思政课立德树人的育人作用，提高中小学思想政治（道德与法治）教研员、一线教师的线教师的线教师的课程教随着新课标、新教材的推广和实施，为进一步发挥思政课立德树人的育人作用，提高中小学思想政治（道德与法治）教研员、一线教师的线教师的线教师的课程教</p>"
        ></MoreInfo>
      </div>
    </div>
    <div class="list">
      <Empty v-if="askDetail.totalCount === 0"  tip="暂无提问！" />
      <van-List
        v-else
        v-model="askDetail.loading"
        :finished="askDetail.finished"
        @load="onLoad"
      >
        <router-link
          v-for="item in askDetail.list" :key="item.id"
          class="list-item"
          :to="{name:'IssueDetail', query:{id:item.id}}"
        >
          <CircleDetailItem :detail="item" />
        </router-link>

        <template #finished>
          <van-divider class="list-bottom-tip">滑到底啦</van-divider>
        </template>
      </van-List>
    </div>
    <div class="footer-wrap iphoneX">
      <div class="footer">
        <router-link
          tag="button"
          type="button"
          class="btn"
          :to="{name:'AskQuestion',params: {id}}"
        ><span>去提问</span></router-link>
        <div class="iphoneX"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { MoreInfo } from '@/components';
import CircleDetailItem from './components/CircleDetailItem';
export default {
  name: 'circleDetail',
  components: { MoreInfo, CircleDetailItem },
  data () {
    return {
      id: '',
      isMore: false,
      detail: {},
      askDetail: {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false
      }
    };
  },
  mounted () {
    let { id } = this.$route.query;
    this.id = id;
    this.getDetail();
  },
  methods: {
    getDetail () {
      let { id, $http } = this;
      $http.get('community/circle/detail', {
        params: {
          id
        },
        showLoading: true,
        customError: true
      }).then((res) => {
        this.detail = res.data || {};
        this.$wxShare({
          // url: window.href, // 网址，默认使用 window.location.href
          title: this.detail.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          desc: this.detail.brief || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          imgUrl: this.detail.coverImage // 图片, 默认取网页中第一个img标签
        });
      }).catch((res) => {
        this.$utils.failToast({
          message: res.msg || '没有该圈子,页面即将返回！',
          onClose: () => {
            this.$router.back();
          }
        });
      });
    },
    onLoad () {
      const { id, askDetail: detail } = this;
      this.$http.get('community/circle/ask/list', {
        params: {
          id,
          pageNo: detail.pageNo,
          pageSize: detail.pageSize
        },
        hideErrorMessage: true
      }).then((res) => {
        let data = res.data || {};
        detail.list.push(...(data.result || []));
        detail.pageNo++;
        detail.totalCount = data.totalCount || 0;
        detail.loading = false;
        detail.finished = !data.isHasNext;
        detail.refreshing = false;
      });
    },
    onFollow () {
      if (this.$goToLogin()) {
        const { detail, id, $http } = this;
        let apiurl = detail.followStatus ? 'community/circle/unFollow' : 'community/circle/follow';
        $http.post(apiurl, { id }).then((res) => {
          this.getDetail();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
#circleDetail {
  .detail {
    padding: 20px 28px 40px;
    .box {
      background-color: #F7F8FC;
      border-radius: 16px;
      padding: 28px 36px;
      display: flex;
      align-items: center;
      .img {
        flex-shrink: 0;
        width: 168px;
        height: 160px;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 40px;
        background-color: #f1f1f1;
      }
      .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .right-top{
          .title {
            font-size: 32px;
            font-weight: bold;
            color: #333444;
            line-height: 44px;
            margin-bottom: 8px;
          }
          .sum {
            display: flex;
            align-items: center;
            .item {
              font-size: 24px;
              display: flex;
              align-items: center;
              .label {
                color: #999AAA;
                margin-right: 8px;
              }
              .value {
                color: #333444;
              }
              &:not(:last-child){
                &:after{
                  content: '';
                  display: block;
                  width: 2px;
                  height: 20px;
                  margin-left: 20px;
                  margin-right: 20px;
                  background-color: #DDDEE6;
                }
              }
            }
          }
        }
        .right-bottom {
          margin-top: 40px;
          .btns {
            display: flex;
            align-items: center;
            .btn {
              min-width: 116px;
              height: 46px;
              font-size: 24px;
              padding-left: 20px;
              padding-right: 20px;
              color: #999AAA;
              background-color: #FFFFFF;
              border: 2px solid #999AAA;
              border-radius: 40px;
              &.btn-1{
                border-color: @primaryGreen;
                color: @primaryGreen;
              }
            }
          }
        }

      }
    }
    .textarea {
      margin-top: 52px;
      padding-bottom: 34px;
      /deep/
      .more-info {
        .more{
          color: @primaryGreen;
        }
      }
    }
  }
  .list {
    padding: 20px 28px 10px;
    background-color: #F7F8FA;
    .list-item{
      display: block;
      &:not(:last-child){
        margin-bottom: 20px;
      }
    }
  }
  .footer-wrap {
    padding-top: 100px;
    .footer {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 999;
      padding: 12px 28px;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.04);
      background-color: #fff;
      .btn {
        width: 100%;
        height: 76px;
        background-image: linear-gradient(90deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
        box-shadow: 0px 6px 12px rgba(79, 157, 255, 0.2);
        border-radius: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        color: #fff;
      }
    }
  }
}
</style>